import { env, compareVersion } from '@funny/env'

export function upgrade() {
  // 只针对运行在站内的活动处理，站外一律按正常处理
  if (!env.browser.isChangba) {
    return
  }
  const result = compareVersion(env.version.cb, '11.20.0')
  if (result === 1) {
    return
  }
  const style = `
    .van-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
    }
    .van-dialog {
      top: 45%;
      width: 320px;
      overflow: hidden;
      font-size: 16px;
      background: #fff;
      border-radius: 16px;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      transition: 0.3s;
      transition-property: transform,opacity
    }
    .van-popup {
      position: fixed;
      max-height: 100%;
      overflow-y: auto;
      box-sizing: border-box;
      background: #fff;
      transition: transform 0.3s;
      -webkit-overflow-scrolling: touch
    }
    .van-popup--center {
      top: 50%;
      left: 0;
      right: 0;
      width: -webkit-fit-content;
      width: fit-content;
      max-width: calc(100vw - 2*16px);
      margin: 0 auto;
      transform: translatey(-50%)
    }
    .van-dialog__header {
      color: #323233;
      padding-top: 26px;
      font-weight: 600;
      line-height: 24px;
      text-align: center
    }
    .van-dialog__content {
      min-width: 320px;
    }
    .van-dialog__footer {
      display: flex;
      overflow: hidden;
      -webkit-user-select: none;
      user-select: none
    }
    .van-dialog__message {
      color: #323233;
      flex: 1;
      max-height: 60vh;
      padding: 26px 24px;
      overflow-y: auto;
      font-size: 14px;
      line-height: 20px;
      white-space: normal;
      text-align: center;
      word-wrap: break-word;
      -webkit-overflow-scrolling: touch
    }
    .van-dialog__message--has-title {
      padding-top: 8px;
      color: #646566;
    }
    .van-dialog__confirm,.van-dialog__confirm:active {
      color: #ff2222 !important;
    }
    .van-dialog__confirm,.van-dialog__cancel {
      flex: 1;
      height: 48px;
      margin: 0;
      border: 0;
      border-radius: 0
    }
    .van-button--large {
      width: 100%;
      height: 50px;
    }
    .van-button--default {
      color: #323233;
      background: #fff;
      border: 1px solid #dcdee0;
    }
    .van-button {
      position: relative;
      display: inline-block;
      box-sizing: border-box;
      height: 44px;
      margin: 0;
      padding: 0;
      font-size: 16px;
      line-height: 1.2;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      transition: opacity 0.2s;
      -webkit-appearance: none;
      -webkit-font-smoothing: auto
    }
    .van-button__content {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%
    }
    .van-button__text{
      color: inherit;
    }
    .van-button__text a {
      color: inherit;
    }
  `
  const styleNode = document.createElement('style')
  styleNode.textContent = style
  // 前者是主站的渲染节点，后者是奥特曼的渲染节点
  const containerEl =
    document.querySelector('.container') || document.querySelector('#app-wrapper') || document.querySelector('#app')
  document.body.removeChild(containerEl)
  const innerHtml = `
  <div class="van-overlay" style="z-index: 2005;"></div>
  <div role="dialog" tabindex="0" class="van-popup van-popup--center van-dialog" aria-labelledby="标题" style="z-index: 2005;">
    <div class="van-dialog__header">升级提示</div>
    <div class="van-dialog__content">
      <div class="van-dialog__message van-dialog__message--has-title">
        当前版本过低，请前往应用商店下载最新版本。如有疑问，请联系客服
      </div>
    </div>
  </div>
  `
  const rootEl = document.createElement('div')
  rootEl.id = 'app'
  rootEl.role = 'upgrade-dialog'
  rootEl.innerHTML = innerHtml
  document.head.appendChild(styleNode)
  document.body.appendChild(rootEl)
  // 抛出为捕获的错误，可以使得后续的代码不继续执行
  throw new Error('系统检测到您当前app版本过低，请升级app再参与~')
}
